import React from 'react';
import { useIntl } from 'react-intl';
import { DictionaryEvidence, Evidence } from '@eas/common-web';
import { useDictionaryEvidence } from '@composite/evidence/dictionary-evidence';
import { MakeDefaultForAgendaButton } from '@components/evidence/dictionary-evidence/dialog-actions/make-default-for-agenda-hook';
import { useDictionaryHookedSources } from '@components/evidence/dictionary-evidence/dictionary-hooked-sources';
import { DictProcessingType } from '@models';
import {
  EntityName,
  EvidenceApiUrl,
  ExportTags,
  HistoryEntityType,
} from '@enums';
import { useColumns } from './dict-processing-type-columns';
import { Fields } from './dict-processing-type-fields';
import { useValidationSchema } from './dict-processing-type-schema';

export function DictProcessingTypes() {
  const intl = useIntl();
  const validationSchema = useValidationSchema();

  const evidence = useDictionaryEvidence<DictProcessingType>({
    version: 6,
    identifier: 'PROCESSING_TYPE',
    apiProps: {
      url: EvidenceApiUrl.DICT_PROCESSING_TYPE,
      hookedSources: useDictionaryHookedSources({
        entityType: HistoryEntityType.PROCESSING_TYPE,
      }),
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'ES__DICT_PROCESSING_TYPES__TABLE__TITLE',
        defaultMessage: 'Typy řízení',
      }),
      reportTag: ExportTags.DICT_PROCESSING_TYPES,
      defaultSorts: [
        { field: 'name', datakey: 'name', order: 'ASC', type: 'FIELD' },
      ],
    },
    detailProps: {
      entityName: EntityName.PROCESSING_TYPE,
      validationSchema,
      GeneralFieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__DICT_PROCESSING_TYPES__DETAIL__TITLE',
          defaultMessage: 'Typ řízení',
        }),
        ActionBar: DictionaryEvidence.dictionaryActionbarFactory({
          After: function AfterButton() {
            return <MakeDefaultForAgendaButton />;
          },
        }),
      },
    },
  });

  return <Evidence {...evidence} />;
}
